import React from 'react';
import { clsx } from 'clsx';

import { useChat } from '@components/Providers';

import { ChatSidebar } from './ChatSidebar';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const ChatPushWrapper: React.FC<Props> = ({ children, className }) => {
  const { isOpen } = useChat();

  return (
    <>
      <div
        className={clsx(
          className,
          'flex h-full flex-1 flex-col overflow-hidden transition-all duration-300 ease-in-out',
          {
            'w-[calc(100%-380px)]': isOpen,
            'w-full': !isOpen,
          },
        )}
      >
        {children}
      </div>

      <ChatSidebar />
    </>
  );
};
